import { z } from 'zod';
/** The text a crew receives when the office confirms their fee for a Job (Jacky, 2 October 2026: "send SMS to
 *  notify installer … you can display the SMS to be sent when I confirm"). Placeholders: {name} {job} {suburb}
 *  {lines} {total} {payment}. Product, crew and customer names are never translated; the wording around them is. */
const Words = z.object({ en: z.string().min(1).max(600), zh: z.string().min(1).max(600) });
export const InstallerFeeNoticeSchema = z.object({
    sms: Words,
    payment: z.object({ cash: Words, transfer: Words, unset: Words }),
    /** how two fee lines are joined in the text */
    line_separator: Words,
});
export const installerFeeNoticeDefaults = {
    sms: {
        en: 'Hi {name}, Artemis Flooring has confirmed your installation fee for job {job} ({suburb}): {lines}. Total {total} ex GST, {payment}. Reply to this number if anything is not right. — Artemis Flooring',
        zh: '{name}您好，Artemis Flooring 已确认您在工程 {job}（{suburb}）的安装费用：{lines}。合计 {total}（不含 GST），{payment}。如有不符请回复此短信。— Artemis Flooring',
    },
    payment: { cash: { en: 'paid in cash', zh: '现金支付' }, transfer: { en: 'paid by bank transfer', zh: '银行转账支付' }, unset: { en: 'payment to be arranged', zh: '付款方式待定' } },
    line_separator: { en: '; ', zh: '；' },
};
//# sourceMappingURL=installer-fee-notice.js.map